import { SVGAttributes } from 'react';

export function ConfigIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="116px"
      height="160px"
      viewBox="-0.5 -0.5 116 160"
      {...props}
    >
      <defs />
      <g>
        <g data-cell-id="0">
          <g data-cell-id="1">
            <g data-cell-id="43s24t3kMvA4kIPissoO-1" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-3" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-4" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-5" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-7" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-8" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-12" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-13" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-14" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-15" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-16" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-17" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-18" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-19" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-20" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-21" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-22" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-29">
              <g />
              <g data-cell-id="43s24t3kMvA4kIPissoO-6">
                <g>
                  <path
                    d="M 53.05 79.03 L 53.04 87.89 C 51 87.27 49.13 85.61 49.13 83.31 C 49.13 81.1 50.72 79.43 53.05 79.03 Z M 59.53 117.45 L 59.53 107.77 C 61.43 108.1 64.75 109.75 64.75 112.88 C 64.75 115.45 62.56 117.34 59.53 117.45 Z M 53.04 139.7 L 59.51 139.68 L 59.51 133.12 C 64.05 132.85 68.96 131.34 72.18 129.17 C 78.51 124.83 81.01 117.82 81.01 111.13 C 81.01 103.67 78.18 99.31 74.59 96.47 C 71.08 93.46 64.71 91.29 59.52 89.99 L 59.46 79.5 C 63.66 80.13 68.09 82.73 71.28 85.41 L 79.39 72.31 C 75.51 68.16 67.52 64.07 59.56 63.42 L 59.57 50.98 L 53.03 50.92 L 53.12 63.33 C 49.66 63.65 46.67 64.39 43.11 66.22 C 35.36 70.65 32.64 78.8 32.91 85.7 C 33.06 94.04 36.82 98.29 40.97 100.84 C 44.92 103.37 49.33 104.79 53.11 105.83 L 53.15 117.17 C 48.64 116.42 42.72 113.11 39.14 109.55 L 30.1 121.95 C 35.88 127.75 43.43 131.87 53.11 132.88 Z M 0.18 160 L 0 0.01 L 72.39 0 L 116 46.92 L 116 159.98 Z"
                    fill="currentColor"
                    stroke="none"
                    pointerEvents="all"
                  />
                  <path
                    d="M 116 93.03 L 72.39 46.92 L 116 46.92 Z"
                    fillOpacity="0.25"
                    fill="currentColor"
                    stroke="none"
                    pointerEvents="all"
                  />
                  <path
                    d="M 116 46.92 L 72.39 46.92 L 72.39 0 Z"
                    fillOpacity="0.25"
                    fill="currentColor"
                    stroke="none"
                    pointerEvents="all"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-27">
                <g>
                  <rect
                    x="0"
                    y="50"
                    width="100"
                    height="110"
                    rx="50"
                    ry="50"
                    fill="currentColor"
                    stroke="none"
                    pointerEvents="all"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-9">
                <g>
                  <path
                    d="M 69.91 131.54 C 79.42 131.54 86.78 123.89 86.78 114.59 C 86.78 106.23 80.35 97.82 69.59 97.82 C 61.88 97.82 53.12 104.15 53.12 114.71 C 53.12 123.51 60.21 131.54 69.91 131.54 Z M 65.39 149 C 62.79 148.55 60.24 147.98 57.82 147 L 57.96 141.32 C 56.18 140.63 54.39 139.62 52.6 138.16 L 47.56 141.14 C 45.79 139.32 44.02 137.55 42.25 135.34 L 45.52 130.48 C 44.47 129.13 43.28 127.06 42.62 124.84 L 36.91 124.8 C 36.31 122.51 35.8 119.99 35.5 116.94 L 40.8 114.87 C 40.69 112.95 40.98 110.27 41.35 108.35 L 36.76 105.2 C 37.54 102.75 38.44 100.34 39.74 98.01 L 45.34 99.08 C 46.28 97.27 47.7 95.59 49.35 93.97 L 47.1 88.86 C 48.95 87.1 51.15 85.59 53.53 84.2 L 57.72 88.08 C 59.74 87.08 62.07 86.42 63.78 86.22 L 64.71 80.49 C 67.37 80.03 70.2 80 72.6 80.26 L 73.91 85.62 C 75.99 85.95 78.07 86.42 80.2 87.23 L 84.01 83.11 C 86.37 84.16 88.67 85.57 90.69 87.08 L 89.02 92.34 C 90.7 94 92.35 95.62 93.26 97.17 L 98.82 95.76 C 100.29 98.01 101.43 100.32 102.31 102.68 L 97.97 106.2 C 98.59 108.36 98.94 110.77 99.06 112.66 L 104.5 114.35 C 104.39 116.97 104.18 120.22 103.65 122.11 L 97.96 122.8 C 97.41 125 96.58 126.93 95.61 128.72 L 99.18 133.17 C 98.08 134.96 96.25 137.32 94.3 139.23 L 89.21 136.65 C 87.92 137.91 86.09 139.26 84 140.2 L 84.54 145.99 C 82.35 147.06 79.89 147.89 77.23 148.54 L 74.33 143.55 C 72.58 143.89 69.83 144.09 67.89 143.79 Z"
                    fill="#ffffff"
                    stroke="none"
                    pointerEvents="all"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-28">
                <g>
                  <path
                    d="M 39.56 67.6 C 46.31 67.6 51.54 62.17 51.54 55.57 C 51.54 49.62 46.97 43.66 39.33 43.66 C 33.85 43.66 27.63 48.15 27.63 55.65 C 27.63 61.9 32.67 67.6 39.56 67.6 Z M 36.34 80 C 34.5 79.68 32.69 79.28 30.97 78.58 L 31.07 74.55 C 29.8 74.05 28.53 73.34 27.26 72.31 L 23.69 74.41 C 22.43 73.13 21.17 71.87 19.91 70.3 L 22.24 66.85 C 21.49 65.89 20.65 64.42 20.18 62.84 L 16.12 62.81 C 15.7 61.19 15.34 59.4 15.12 57.23 L 18.88 55.76 C 18.81 54.4 19.01 52.49 19.27 51.13 L 16.02 48.9 C 16.57 47.16 17.21 45.45 18.13 43.79 L 22.11 44.55 C 22.78 43.27 23.78 42.07 24.95 40.92 L 23.36 37.29 C 24.67 36.05 26.24 34.97 27.92 33.98 L 30.9 36.74 C 32.34 36.03 33.99 35.56 35.2 35.42 L 35.86 31.35 C 37.76 31.02 39.76 31 41.47 31.18 L 42.4 34.99 C 43.87 35.23 45.35 35.56 46.86 36.13 L 49.57 33.21 C 51.25 33.95 52.88 34.95 54.32 36.03 L 53.13 39.76 C 54.32 40.94 55.49 42.09 56.14 43.19 L 60.09 42.19 C 61.13 43.79 61.94 45.43 62.57 47.11 L 59.48 49.61 C 59.92 51.14 60.18 52.85 60.26 54.19 L 64.12 55.39 C 64.04 57.25 63.89 59.56 63.52 60.9 L 59.48 61.39 C 59.08 62.95 58.5 64.33 57.81 65.6 L 60.34 68.76 C 59.56 70.03 58.26 71.7 56.88 73.06 L 53.26 71.23 C 52.35 72.13 51.05 73.09 49.56 73.75 L 49.95 77.86 C 48.39 78.62 46.64 79.21 44.75 79.68 L 42.7 76.13 C 41.45 76.37 39.5 76.51 38.12 76.3 Z"
                    fill="#ffffff"
                    stroke="none"
                  />
                </g>
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-25" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-33" />
          </g>
        </g>
      </g>
    </svg>
  );
}
